const card_options = document.querySelectorAll(".card-option");

card_options.forEach((card) => {
    card.addEventListener("click", () => {
        const url = card.getAttribute("data-url");
        if (url) {
            window.location.href = url;
        }
    });
});
